<template>
  <div class="XYtree">
    <div>
      <a-tree
        v-if="mydata.length && asyn"
        show-line
        :selected-keys.sync="selectedKeys"
        :default-expanded-keys="selectedKeys"
        :auto-expand-parent="true"
        :load-data="onLoadData"
        :tree-data="mydata"
        @select="onSelect"
      />
      <a-tree
        v-if="mydata.length && !asyn"
        :auto-expand-parent="true"
        :default-expand-parent="true"
        :default-expanded-keys="selectedKeys"
        :selected-keys.sync="selectedKeys"
        show-line
        :tree-data="mydata"
        @select="onSelect"
      />
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      treeData: {
        type: Array,
        default() {
          return [
            // {
            //   title: 1,
            //   key: 1,
            //   children: [
            //     { title: '1 - 1', key: '1 - 1', children: [] },
            //     { title: '1 - 2', key: '1 - 2', children: [] }
            //   ]
            // },
          ]
        }
      },
      asyn: {
        type: Boolean,
        default: false
      },
      defaultKey: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return { mydata: [], selectedKeys: [] }
    },
    watch: {
      treeData: {
        handler() {
          this.mydata = this.treeData.map(i => this.mapTree(i))
        },
        immediate: true
      },
      defaultKey: {
        handler(val) {
          this.selectedKeys = val
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      onSelect(selectedKeys, info) {
        this.$emit(
          'treeSelect',
          selectedKeys,
          info.node.$options.propsData.dataRef
        )
      },
      mapTree(org, parent = { key: 0, pathIds: [0] }) {
        const haveChildren =
          Array.isArray(org.children) && org.children.length > 0
        let item = {
          key: org.key,
          ...org,
          pathIds: [...parent.pathIds, org.key]
        }
        return {
          // 分别将我们查询出来的值做出改变他的key
          title: org.title,
          key: org.key,
          ...org,
          parent: parent,
          pathIds: [...parent.pathIds, org.key], // 深度 循环 依次key  用于查询
          // 判断它是否存在子集，若果存在就进行再次进行遍历操作，知道不存在子集便对其他的元素进行操作
          children: haveChildren
            ? org.children.map(i => this.mapTree(i, item))
            : []
        }
      },
      onLoadData(treeNode) {
        return new Promise(resolve => {
          if (treeNode.dataRef.children.length) {
            resolve()
            return
          }
          this.$emit('onLoadData', treeNode, resolve)
        })
      }
    }
  }
</script>

<style lang="less">
  .XYtree {
    width: 100%;
    height: 100%;
    padding: 10px 24px;
    overflow: auto;
    &:hover::-webkit-scrollbar-thumb {
      visibility: visible;
    }

    .ant-tree.ant-tree-show-line li:not(:last-child):before {
      position: absolute;
      left: 12px;
      width: 1px;
      height: 100%;
      height: calc(100% - 22px);
      margin: 22px 0 0;
      border-left: @border-width-base #d9d9d9 dashed;
      content: ' ';
    }

    .ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
      display: inline-block;
      background-image: url('./open.png') !important ;
      background-size: 14px !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      i {
        display: none;
      }
    }

    .ant-tree {
      font-size: @font-size-base;
      font-weight: 400;
      line-height: 32px;
      color: @text-color-secondary;
    }

    .ant-tree-node-selected {
      font-weight: 500 !important;
      color: @primary-color !important;
      background-color: #dceeff !important;
    }
    .ant-tree-switcher,
    .ant-tree-title,
    .ant-tree-node-content-wrapper {
      height: 32px !important;
      line-height: 32px !important;
      display: inline-block;
      // width: 85%;
    }
    .ant-tree-node-content-wrapper {
      line-height: 32px;
      width: calc(100% - 32px) !important;
      .ant-tree-title {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .ant-tree-switcher_close {
      background-image: url('./close.png') !important ;
      background-size: 14px !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      i {
        display: none;
      }
    }
    //打开样式
    .ant-tree-switcher_open {
      background-image: url('./open.png') !important ;
      background-size: 14px !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      i {
        display: none;
      }
    }
  }
</style>
